import { useState } from 'react';
import { packSizeAPI } from '../services/api';

export const useCalculation = () => {
  const [itemsWanted, setItemsWanted] = useState('');
  const [results, setResults] = useState([]);
  const [calculating, setCalculating] = useState(false);
  const [error, setError] = useState('');

  const calculate = async (packSizes) => {
    const items = parseInt(itemsWanted, 10);

    if (isNaN(items) || !Number.isInteger(items) || items <= 0) {
      setError('Please enter a valid positive integer');
      setResults([]);
      return false;
    }

    if (packSizes.length === 0) {
      setError('No pack sizes available. Please add pack sizes first');
      return false;
    }

    setError('');
    setCalculating(true);
    
    try {
      // Rebuild the pack sizes on the server first to ensure they are valid and up-to-date
      await packSizeAPI.rebuildPackSizes(packSizes);
      
      // Calculate the results
      const calcResults = await packSizeAPI.calculatePacks(items);
      setResults(calcResults);
      return true;
    } catch (err) {
      setError('Calculation failed. Please try again');
      return false;
    } finally {
      setCalculating(false);
    }
  };

  return {
    itemsWanted,
    setItemsWanted,
    results,
    calculating,
    error,
    calculate
  };
};
